import React from 'react'
import { useState } from 'react';

import "./css/slotm.css";
const SlotMachine = () => {
    //let x = "1";
    // let y = "1";
    // let z = "1";
    const [x, useX] = useState(0);
    const [y, useY] = useState(0);
    const [z, useZ] = useState(0);
  
    function GenerateNumber() {
      useX(Math.floor(Math.random() * 10));
      useY(Math.floor(Math.random() * 10));
      useZ(Math.floor(Math.random() * 10));
    };
    if (x === y && y === z) {
      return (
        <>
          <div>
            <hr />
            <h1>
              {x} {y} {z}
            </h1>
            <h3>Congratulations!!!!</h3>
            <hr />
          </div>
          <button id="repeatButton" onClick={() => GenerateNumber()}></button>
        </>
      );
    } else {
      return (
        <>
          <div>
            <hr />
            <h1>
              {x} {y} {z}
            </h1>
            <h3>This is not matching</h3>
            <hr />
          </div>
          <button id="repeatButton" onClick={() => GenerateNumber()}></button>
        </>
      );
    }
  };
function SlotM() {
    return (
      <>
        
        <div className="slotmachine">
            <h1 className="heading">Slot Machine Game</h1>
            <SlotMachine />
        </div>
      </>
    );
  }

export default SlotM